module.exports = __webpack_public_path__ + "static/media/poster5.cdbd973a.jpg";